<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-input v-model="filter.userName" placeholder="请输入转出方用户名" style="float: left;"></el-input>
        <el-input v-model="filter.userPhone" placeholder="请输入转出方手机号" style="float: left;"></el-input>
        <el-input v-model="filter.otherName" placeholder="请输入转入方用户名" style="float: left;"></el-input>
        <el-input v-model="filter.otherPhone" placeholder="请输入转入方手机号" style="float: left;"></el-input>
        <el-button @click="_getList" type="primary" style="float: left;">搜索</el-button>
        <el-pagination background layout="prev, pager, next" :current-page="pageNum"
                       @current-change="pageChange"
                       :total="totalNum" v-if="paginationShow"></el-pagination>

      </div>
      <div class="categoryTable">
        <el-table ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%" border>
          <el-table-column prop="userName" label="转出方用户名" />
          <el-table-column prop="userPhone" label="转出方手机号" />
          <el-table-column prop="otherName" label="转入方用户名" />
          <el-table-column prop="otherPhone" label="转入方手机号"/>
          <el-table-column prop="money" label="转账金额" />
          <el-table-column prop="insertTime" label="转账时间" >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {Loading} from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getFinanceCoupon} from 'api/request'
import {ERR_OK} from 'api/config'
import {loadingInstance, Error} from 'common/js/util'

export default {
  components: {MSidebar, MHeader},
  data () {
    return {
      status: 1,
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      paginationShow: false,
      list: [],
      filter:{
        userName:'',
        userPhone:'',
        otherName:'',
        otherPhone:'',
      },
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'))
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    } else {
      this._getList()
    }
  },
  methods: {
    // 点击分页
    pageChange (val) {
      this.pageNum = val
      this.categoryDatas = []
      this._getList()
    },
    onOption(index, row,status){
      this.showRejectModal = true
      this.editRow = row
      this.status = status
    },
    onModalOk(){
      if (!this.checkRemark) {
        this.$message('请填写备注')
        return
      }
      let param = {
        id: this.editRow.id,
        status: this.status,
        checkRemark: this.checkRemark
      }
      loadingInstance(Loading)
      postFinanceStore(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.checkRemark = null
          this.showRejectModal = false
          let text = this.status == '1'?'同意':'拒绝';
          this.$message(text)
          this._getList()
        } else {
          Error(this, res)
        }
      })
    },
    // 获取列表
    _getList () {
      let param = {
        current: this.pageNum,
        size: this.pageSize,
        userName:this.filter.userName,
        userPhone:this.filter.userPhone,
        otherName:this.filter.otherName,
        otherPhone:this.filter.otherPhone,
      }
      loadingInstance(Loading)
      getFinanceCoupon(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.list = res.data.records
          this.totalNum = res.data.total
          if (res.data.pages > 1) {
            this.paginationShow = true
          }
        } else {
          Error(this, res)
        }
      })
    }
  }
}
</script>
<style scoped>
.userOperate{
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.userOperate .el-input {
  width:180px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}
.userOperate .el-button {
  width:100px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}

.categoryOperate {
  height: 40px;
  margin: 20px;
  box-sizing: border-box;
}

.categoryTable {
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}
</style>
<style>
.el-tag + .el-tag {
  margin: 5px;
}

.categoryOperate .el-input {
  width: 180px;
  height: 40px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}

.categoryOperate .el-button {
  width: 100px;
  height: 40px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/finance/coupon.vue